﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const OperationalContextClient_1 = require("./swagger/OperationalContextClient");
class FieldLimitClient {
    constructor() {
        this.client = new OperationalContextClient_1.OperationalContextClient();
    }
    getAll() {
        return this.client.apiFieldlimitsGet();
    }
}
exports.FieldLimitClient = FieldLimitClient;
//# sourceMappingURL=FieldLimitClient.js.map